module.exports = __webpack_public_path__ + "static/media/glitchedtones_Door+Creak+01.a8171588.wav";